const backgroundColors = [
  '#BFDF95',
  '#BCD6FB',
  '#FECC7C',
  '#FDBDBD',
  '#DFCCFB',
  '#D4D4D4',
  '#FFFFFF',
  '#000000',
  '#584364',
  '#8E230B',
  '#4B4B4B',
  '#6C410E',
];

export const getFullName = (firstName: string, lastName: string): string => {
  if (firstName) {
    if (lastName) {
      return `${firstName} ${lastName}`;
    }
    return firstName;
  }
  if (lastName) {
    return lastName;
  }
  return 'Anonymous';
};

export const getUserFullName = (user?: { firstName: string; lastName: string }): string => {
  return user ? getFullName(user.firstName, user.lastName) : '';
};

export const getAlphabeticOnly = (word: string): string => {
  return word.replace(/[^\s\w]+/g, '');
};

export const concatInitials = (fullName: string): string => {
  let initials: string = getAlphabeticOnly(fullName)
    .split(' ')
    .reduce((a, c) => a + c.charAt(0), '');
  if (initials.length > 2) {
    if (initials.search(/[A-Z]/) > -1) {
      initials = initials.replace(/[^A-Z]+/g, '');
    }
  }
  return initials.substring(0, 2).toUpperCase();
};

export const capitalize = (s: string): string => {
  if (!s) {
    return s;
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getColor = (name?: string): string => {
  const index = (name?.length || 0) % backgroundColors.length;
  return index <= 6 ? '#000000' : '#FFFFFF';
};

export const getBgColor = (name?: string): string => {
  const index = (name?.length || 0) % backgroundColors.length;
  return name ? backgroundColors[index] : 'transparent';
};
